function getItemsToShow() {
    const width = $(window).width();
    if (width < 576) return 1;
    if (width < 1118) return 1;
    return 1;
}

$(document).ready(function () {
    //Check for hero-carousel and then for hero-carousel-image
    let $section = $('.hero-carousel-section');
    $section.length || ($section = $('.hero-carousel-image-section'));

    let $wrapper = $('.hero-carousel-wrapper');
    $wrapper.length || ($wrapper = $('.hero-carousel-image-wrapper'));

    let $carousel = $wrapper.find('.hero-carousel');
    $carousel.length || ($carousel = $wrapper.find('.hero-image-carousel'));

    const $leftArrow = $section.find('.left-arrow');
    const $rightArrow = $section.find('.right-arrow');
    const $dotsContainer = $section.find('.slider-dots-container');

    $section.attr('tabindex', '0');

    let itemsToShow = getItemsToShow();

    $carousel.slick({
        slidesToShow: itemsToShow,
        slidesToScroll: 1,
        infinite: false,
        arrows: false,
        dots: false,
        adaptiveHeight: true,
        responsive: [
            {
                breakpoint: 1118,
                settings: {
                    slidesToShow: 1
                }
            },
            {
                breakpoint: 576,
                settings: {
                    slidesToShow: 1
                }
            }
        ]
    });

    setTimeout(() => {
        $carousel.slick('setPosition');
    }, 100);

    $('img.lazy').on('load', function () {
        $carousel.slick('setPosition');
    });

    const totalItems = $carousel.slick("getSlick").slideCount;

    $dotsContainer.empty();
    for (let i = 0; i < totalItems; i++) {
        $dotsContainer.append(`<span class="dot" data-index="${i}"></span>`);
    }

    const $dots = $dotsContainer.find('.dot');

    $dots.on('click', function () {
        const targetIndex = parseInt($(this).attr('data-index'));
        $carousel.slick('slickGoTo', targetIndex);
    });

    $leftArrow.on('click', function () {
        $carousel.slick('slickPrev');
    });

    $rightArrow.on('click', function () {
        $carousel.slick('slickNext');
    });
    function updateArrowStates(currentSlide, slick) {
        const maxIndex = slick.slideCount - slick.options.slidesToShow;
        const width = $(window).width();
        let activeColor = '#8E9093';
        let inactiveColor = '#E6E7E8';

        if (width <= 576) {
            activeColor = '#939598';
            inactiveColor = '#E6E7E8';
        } else if (width <= 1117) {
            activeColor = '#939598';
            inactiveColor = '#E6E7E8';
        }

        if (currentSlide <= 0) {
            $leftArrow.css('pointer-events', 'none');
            $leftArrow.find('path').attr('fill', inactiveColor);
        } else {
            $leftArrow.css('pointer-events', 'auto');
            $leftArrow.find('path').attr('fill', activeColor);
        }

        if (currentSlide >= maxIndex) {
            $rightArrow.css('pointer-events', 'none');
            $rightArrow.find('path').attr('fill', inactiveColor);
        } else {
            $rightArrow.css('pointer-events', 'auto');
            $rightArrow.find('path').attr('fill', activeColor);
        }
    }

    $carousel.on('afterChange', function (event, slick, currentSlide) {
        $dots.removeClass('active');
        $dots.eq(currentSlide).addClass('active');
        updateArrowStates(currentSlide, slick);
        $carousel.slick('setPosition');
    });

    $carousel.slick('slickGoTo', 0, true);
    updateArrowStates(0, $carousel.slick('getSlick'));

    $section.on('keydown', function (e) {
        if (e.key === 'ArrowLeft') {
            $carousel.slick('slickPrev');
        } else if (e.key === 'ArrowRight') {
            $carousel.slick('slickNext');
        }
    });

    $(window).on('resize', function () {
        itemsToShow = getItemsToShow();
        $carousel.slick('slickSetOption', 'slidesToShow', itemsToShow, true);
        $carousel.slick('slickSetOption', 'slidesToScroll', 1, true);
        $carousel.slick('setPosition');
    });
});